import React from 'react'
import PropTypes from 'prop-types'

import {Box} from '@salesforce/retail-react-app/app/components/shared/ui'

const Video = ({src, preload = 'metadata', ...props}) => {
    return <Box as="video" src={src} preload={preload} width="100%" objectFit="cover" alignSelf="center" {...props} />
}

Video.propTypes = {
    src: PropTypes.string,
    preload: PropTypes.oneOf(['none', 'metadata', 'auto'])
}

export default Video
